import React from 'react';

const spinnerSizes = {
  small: 'w-4 h-4',
  medium: 'w-8 h-8',
  large: 'w-12 h-12',
};

export const LoadingSpinner = ({ size = 'medium', className = '' }) => (
  <div
    className={`inline-block animate-spin rounded-full border-4 border-solid border-current border-r-transparent ${spinnerSizes[size]} ${className}`}
    role="status"
    aria-label="loading"
  >
    <span className="sr-only">טוען...</span>
  </div>
);
